module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@tkey/common-types");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("json-stable-stringify");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/http-helpers");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("web3-utils");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("bn.js");

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "MockStorageLayer", function() { return /* reexport */ src_MockStorageLayer; });
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_TorusStorageLayer; });
__webpack_require__.d(__webpack_exports__, "TorusStorageLayer", function() { return /* reexport */ src_TorusStorageLayer; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(7);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(8);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(4);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(1);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@tkey/common-types"
var common_types_ = __webpack_require__(0);

// EXTERNAL MODULE: external "json-stable-stringify"
var external_json_stable_stringify_ = __webpack_require__(3);
var external_json_stable_stringify_default = /*#__PURE__*/__webpack_require__.n(external_json_stable_stringify_);

// CONCATENATED MODULE: ./src/MockStorageLayer.ts








var MockStorageLayer_MockStorageLayer = /*#__PURE__*/function () {
  function MockStorageLayer(_ref) {
    var dataMap = _ref.dataMap,
        serviceProvider = _ref.serviceProvider,
        lockMap = _ref.lockMap;

    classCallCheck_default()(this, MockStorageLayer);

    defineProperty_default()(this, "dataMap", void 0);

    defineProperty_default()(this, "lockMap", void 0);

    defineProperty_default()(this, "serviceProvider", void 0);

    this.dataMap = dataMap || {};
    this.serviceProvider = serviceProvider;
    this.lockMap = lockMap || {};
  }
  /**
   *  Get metadata for a key
   * @param privKey If not provided, it will use service provider's share for decryption
   */


  createClass_default()(MockStorageLayer, [{
    key: "getMetadata",
    value: function () {
      var _getMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(params) {
        var serviceProvider, privKey, usedKey, fromMap;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey;
                if (!privKey) usedKey = serviceProvider.retrievePubKeyPoint().getX();else usedKey = Object(common_types_["getPubKeyPoint"])(privKey).x;
                fromMap = this.dataMap[usedKey.toString("hex")];

                if (fromMap) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Object.create({
                  message: common_types_["KEY_NOT_FOUND"]
                }));

              case 5:
                return _context.abrupt("return", JSON.parse(this.dataMap[usedKey.toString("hex")]));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMetadata(_x) {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }()
    /**
     * Set Metadata for a key
     * @param input data to post
     * @param privKey If not provided, it will use service provider's share for encryption
     */

  }, {
    key: "setMetadata",
    value: function () {
      var _setMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(params) {
        var serviceProvider, privKey, input, usedKey;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey, input = params.input;
                if (!privKey) usedKey = serviceProvider.retrievePubKeyPoint().getX();else usedKey = Object(common_types_["getPubKeyPoint"])(privKey).x;
                this.dataMap[usedKey.toString("hex")] = external_json_stable_stringify_default()(input);
                return _context2.abrupt("return", {
                  message: "success"
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setMetadata(_x2) {
        return _setMetadata.apply(this, arguments);
      }

      return setMetadata;
    }()
  }, {
    key: "setMetadataStream",
    value: function () {
      var _setMetadataStream = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(params) {
        var _this = this;

        var serviceProvider, privKey, input;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey, input = params.input;
                input.forEach(function (el, index) {
                  var usedKey;
                  if (!privKey || !privKey[index]) usedKey = serviceProvider.retrievePubKeyPoint().getX();else usedKey = Object(common_types_["getPubKeyPoint"])(privKey[index]).x;
                  _this.dataMap[usedKey.toString("hex")] = external_json_stable_stringify_default()(el);
                });
                return _context3.abrupt("return", {
                  message: "success"
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function setMetadataStream(_x3) {
        return _setMetadataStream.apply(this, arguments);
      }

      return setMetadataStream;
    }()
  }, {
    key: "acquireWriteLock",
    value: function () {
      var _acquireWriteLock = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(params) {
        var serviceProvider, privKey, usedKey, id;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey;
                if (!privKey) usedKey = serviceProvider.retrievePubKeyPoint().getX();else usedKey = Object(common_types_["getPubKeyPoint"])(privKey).x;

                if (!this.lockMap[usedKey.toString("hex")]) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", {
                  status: 0
                });

              case 4:
                id = Object(common_types_["generateID"])();
                this.lockMap[usedKey.toString("hex")] = id;
                return _context4.abrupt("return", {
                  status: 1,
                  id: id
                });

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function acquireWriteLock(_x4) {
        return _acquireWriteLock.apply(this, arguments);
      }

      return acquireWriteLock;
    }()
  }, {
    key: "releaseWriteLock",
    value: function () {
      var _releaseWriteLock = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(params) {
        var serviceProvider, privKey, id, usedKey;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey, id = params.id;
                if (!privKey) usedKey = serviceProvider.retrievePubKeyPoint().getX();else usedKey = Object(common_types_["getPubKeyPoint"])(privKey).x;

                if (this.lockMap[usedKey.toString("hex")]) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", {
                  status: 0
                });

              case 4:
                if (!(id !== this.lockMap[usedKey.toString("hex")])) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", {
                  status: 2
                });

              case 6:
                this.lockMap[usedKey.toString("hex")] = null;
                return _context5.abrupt("return", {
                  status: 1
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function releaseWriteLock(_x5) {
        return _releaseWriteLock.apply(this, arguments);
      }

      return releaseWriteLock;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        dataMap: this.dataMap,
        serviceProvider: this.serviceProvider
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var dataMap = value.dataMap,
          serviceProvider = value.serviceProvider,
          lockMap = value.lockMap;
      return new MockStorageLayer({
        dataMap: dataMap,
        serviceProvider: serviceProvider,
        lockMap: lockMap
      });
    }
  }]);

  return MockStorageLayer;
}();

/* harmony default export */ var src_MockStorageLayer = (MockStorageLayer_MockStorageLayer);
// EXTERNAL MODULE: external "@toruslabs/http-helpers"
var http_helpers_ = __webpack_require__(5);

// EXTERNAL MODULE: external "bn.js"
var external_bn_js_ = __webpack_require__(9);
var external_bn_js_default = /*#__PURE__*/__webpack_require__.n(external_bn_js_);

// EXTERNAL MODULE: external "web3-utils"
var external_web3_utils_ = __webpack_require__(6);

// CONCATENATED MODULE: ./src/TorusStorageLayer.ts











function signDataWithPrivKey(data, privKey) {
  var sig = common_types_["ecCurve"].sign(Object(common_types_["stripHexPrefix"])(Object(external_web3_utils_["keccak256"])(external_json_stable_stringify_default()(data))), Object(common_types_["toPrivKeyECC"])(privKey), "utf-8");
  return sig.toDER();
}

var TorusStorageLayer_TorusStorageLayer = /*#__PURE__*/function () {
  function TorusStorageLayer(_ref) {
    var _ref$enableLogging = _ref.enableLogging,
        enableLogging = _ref$enableLogging === void 0 ? false : _ref$enableLogging,
        _ref$hostUrl = _ref.hostUrl,
        hostUrl = _ref$hostUrl === void 0 ? "http://localhost:5051" : _ref$hostUrl,
        serviceProvider = _ref.serviceProvider;

    classCallCheck_default()(this, TorusStorageLayer);

    defineProperty_default()(this, "enableLogging", void 0);

    defineProperty_default()(this, "hostUrl", void 0);

    defineProperty_default()(this, "serviceProvider", void 0);

    this.enableLogging = enableLogging;
    this.hostUrl = hostUrl;
    this.serviceProvider = serviceProvider;
  }
  /**
   *  Get metadata for a key
   * @param privKey If not provided, it will use service provider's share for decryption
   */


  createClass_default()(TorusStorageLayer, [{
    key: "getMetadata",
    value: function () {
      var _getMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(params) {
        var serviceProvider, privKey, keyDetails, metadataResponse, encryptedMessage, decrypted;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey;
                keyDetails = this.generateMetadataParams({}, serviceProvider, privKey);
                _context.next = 4;
                return Object(http_helpers_["post"])("".concat(this.hostUrl, "/get"), keyDetails);

              case 4:
                metadataResponse = _context.sent;

                if (!(metadataResponse.message === "")) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Object.create({
                  message: common_types_["KEY_NOT_FOUND"]
                }));

              case 7:
                encryptedMessage = JSON.parse(atob(metadataResponse.message));

                if (!privKey) {
                  _context.next = 14;
                  break;
                }

                _context.next = 11;
                return Object(common_types_["decrypt"])(Object(common_types_["toPrivKeyECC"])(privKey), encryptedMessage);

              case 11:
                decrypted = _context.sent;
                _context.next = 17;
                break;

              case 14:
                _context.next = 16;
                return serviceProvider.decrypt(encryptedMessage);

              case 16:
                decrypted = _context.sent;

              case 17:
                return _context.abrupt("return", JSON.parse(decrypted.toString()));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMetadata(_x) {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }()
    /**
     * Set Metadata for a key
     * @param input data to post
     * @param privKey If not provided, it will use service provider's share for encryption
     */

  }, {
    key: "setMetadata",
    value: function () {
      var _setMetadata = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(params) {
        var serviceProvider, privKey, input, bufferMetadata, encryptedDetails, serializedEncryptedDetails, metadataParams;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey, input = params.input;
                bufferMetadata = Buffer.from(external_json_stable_stringify_default()(input));

                if (!privKey) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 5;
                return Object(common_types_["encrypt"])(Object(common_types_["getPubKeyECC"])(privKey), bufferMetadata);

              case 5:
                encryptedDetails = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.next = 10;
                return serviceProvider.encrypt(bufferMetadata);

              case 10:
                encryptedDetails = _context2.sent;

              case 11:
                serializedEncryptedDetails = btoa(external_json_stable_stringify_default()(encryptedDetails));
                metadataParams = this.generateMetadataParams(serializedEncryptedDetails, serviceProvider, privKey);
                return _context2.abrupt("return", Object(http_helpers_["post"])("".concat(this.hostUrl, "/set"), metadataParams));

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setMetadata(_x2) {
        return _setMetadata.apply(this, arguments);
      }

      return setMetadata;
    }()
  }, {
    key: "setMetadataStream",
    value: function () {
      var _setMetadataStream = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(params) {
        var _this = this;

        var serviceProvider, privKey, input, newInput, finalMetadataParams, FD, options, customOptions;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey, input = params.input;
                newInput = input;
                _context4.next = 4;
                return Promise.all(newInput.map( /*#__PURE__*/function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(el, i) {
                    var bufferMetadata, encryptedDetails, serializedEncryptedDetails, metadataParams;
                    return regenerator_default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            bufferMetadata = Buffer.from(external_json_stable_stringify_default()(el));

                            if (!privKey[i]) {
                              _context3.next = 7;
                              break;
                            }

                            _context3.next = 4;
                            return Object(common_types_["encrypt"])(Object(common_types_["getPubKeyECC"])(privKey[i]), bufferMetadata);

                          case 4:
                            encryptedDetails = _context3.sent;
                            _context3.next = 10;
                            break;

                          case 7:
                            _context3.next = 9;
                            return serviceProvider.encrypt(bufferMetadata);

                          case 9:
                            encryptedDetails = _context3.sent;

                          case 10:
                            serializedEncryptedDetails = btoa(external_json_stable_stringify_default()(encryptedDetails));
                            metadataParams = _this.generateMetadataParams(serializedEncryptedDetails, serviceProvider, privKey[i]);
                            return _context3.abrupt("return", metadataParams);

                          case 13:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4, _x5) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 4:
                finalMetadataParams = _context4.sent;
                FD = new FormData();
                finalMetadataParams.forEach(function (el, index) {
                  FD.append(index.toString(), JSON.stringify(el));
                });
                options = {
                  mode: "cors",
                  method: "POST",
                  headers: {
                    "Content-Type": undefined
                  }
                };
                customOptions = {
                  isUrlEncodedData: true
                };
                return _context4.abrupt("return", Object(http_helpers_["post"])("".concat(this.hostUrl, "/bulk_set_stream"), FD, options, customOptions));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setMetadataStream(_x3) {
        return _setMetadataStream.apply(this, arguments);
      }

      return setMetadataStream;
    }()
  }, {
    key: "generateMetadataParams",
    value: function generateMetadataParams(message, serviceProvider, privKey) {
      var sig;
      var pubX;
      var pubY;
      var setTKeyStore = {
        data: message,
        timestamp: new external_bn_js_default.a(~~(Date.now() / 1000)).toString(16)
      };
      var hash = Object(external_web3_utils_["keccak256"])(external_json_stable_stringify_default()(setTKeyStore)).slice(2);

      if (privKey) {
        var unparsedSig = Object(common_types_["toPrivKeyEC"])(privKey).sign(hash);
        sig = Buffer.from(unparsedSig.r.toString(16, 64) + unparsedSig.s.toString(16, 64) + new external_bn_js_default.a(0).toString(16, 2), "hex").toString("base64");
        var pubK = Object(common_types_["getPubKeyPoint"])(privKey);
        pubX = pubK.x.toString("hex");
        pubY = pubK.y.toString("hex");
      } else {
        var point = serviceProvider.retrievePubKeyPoint();
        sig = this.serviceProvider.sign(hash);
        pubX = point.getX().toString("hex");
        pubY = point.getY().toString("hex");
      }

      return {
        pub_key_X: pubX,
        pub_key_Y: pubY,
        set_data: setTKeyStore,
        signature: sig,
        namespace: "tkey"
      };
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "acquireWriteLock",
    value: function () {
      var _acquireWriteLock = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(params) {
        var serviceProvider, privKey, data, signature, metadataParams;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey;
                data = {
                  timestamp: Math.floor(Date.now() / 1000)
                };

                if (privKey) {
                  signature = signDataWithPrivKey(data, privKey);
                } else {
                  signature = serviceProvider.sign(Object(common_types_["stripHexPrefix"])(Object(external_web3_utils_["keccak256"])(external_json_stable_stringify_default()(data))));
                }

                metadataParams = {
                  key: Object(common_types_["toPrivKeyEC"])(privKey).getPublic("hex"),
                  data: data,
                  signature: signature
                };
                return _context5.abrupt("return", Object(http_helpers_["post"])("".concat(this.hostUrl, "/acquireLock"), metadataParams));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function acquireWriteLock(_x6) {
        return _acquireWriteLock.apply(this, arguments);
      }

      return acquireWriteLock;
    }() // eslint-disable-next-line class-methods-use-this

  }, {
    key: "releaseWriteLock",
    value: function () {
      var _releaseWriteLock = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(params) {
        var serviceProvider, privKey, id, data, signature, metadataParams;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                serviceProvider = params.serviceProvider, privKey = params.privKey, id = params.id;
                data = {
                  timestamp: Math.floor(Date.now() / 1000)
                };

                if (privKey) {
                  signature = signDataWithPrivKey(data, privKey);
                } else {
                  signature = serviceProvider.sign(Object(common_types_["stripHexPrefix"])(Object(external_web3_utils_["keccak256"])(external_json_stable_stringify_default()(data))));
                }

                metadataParams = {
                  key: Object(common_types_["toPrivKeyEC"])(privKey).getPublic("hex"),
                  data: data,
                  signature: signature,
                  id: id
                };
                return _context6.abrupt("return", Object(http_helpers_["post"])("".concat(this.hostUrl, "/releaseLock"), metadataParams));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function releaseWriteLock(_x7) {
        return _releaseWriteLock.apply(this, arguments);
      }

      return releaseWriteLock;
    }()
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        enableLogging: this.enableLogging,
        hostUrl: this.hostUrl
      };
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var enableLogging = value.enableLogging,
          hostUrl = value.hostUrl,
          serviceProvider = value.serviceProvider;
      return new TorusStorageLayer({
        enableLogging: enableLogging,
        hostUrl: hostUrl,
        serviceProvider: serviceProvider
      });
    }
  }]);

  return TorusStorageLayer;
}();

/* harmony default export */ var src_TorusStorageLayer = (TorusStorageLayer_TorusStorageLayer);
// CONCATENATED MODULE: ./index.ts



/***/ })
/******/ ]);